import { useCallback } from 'react'
import { AnnotationGenerator } from './AnnotationGenerator'
import { globalScroller, navigateToPage } from './AnnotationScroller'
import { generateAnnotationsOld } from './highlightingUtils'


export function useAnnotationManager(enableAnnotationScrolling = false, options = { extractAllRuleDataPoints: false }) {
  const generateAnnotations = useCallback((data, pdfParsingResult, globalFields) => {
    if (enableAnnotationScrolling) {
      const generator = new AnnotationGenerator(data, pdfParsingResult, globalFields, options)
      return generator.generate()
    } else {
      return generateAnnotationsOld(data, pdfParsingResult, globalFields)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enableAnnotationScrolling])


  const scrollToAnnotation = useCallback(async (
    fieldId,
    comparableNumber = null,
    fieldIdToPage = {},
    pageNavigationPlugin = null,
    comparableToPage = {}
  ) => {
    return globalScroller.scrollToAnnotation(
      fieldId,
      comparableNumber,
      fieldIdToPage,
      pageNavigationPlugin,
      comparableToPage
    )
  }, [])

  const clearAnnotationHighlight = useCallback(() => {
    globalScroller.clearCurrentAnnotationHighlight()
  }, [])

  const scrollToFieldLocation = useCallback(async (
    fieldId,
    comparableNumber = null,
    fieldIdToPage = {},
    pageNavigationPlugin = null,
    comparableToPage = {},
    globalFields = [],
    pdfParsingResult = null
  ) => {
    if (enableAnnotationScrolling) {
      const success = await scrollToAnnotation(
        fieldId,
        comparableNumber,
        fieldIdToPage,
        pageNavigationPlugin,
        comparableToPage
      )
      if (!success) {
        navigateToPage(
          fieldId,
          comparableNumber,
          fieldIdToPage,
          pageNavigationPlugin,
          globalFields,
          pdfParsingResult
        )
      }
    } else {
      navigateToPage(
        fieldId,
        comparableNumber,
        fieldIdToPage,
        pageNavigationPlugin,
        globalFields,
        pdfParsingResult
      )
    }
  }, [enableAnnotationScrolling, scrollToAnnotation])


  return {
    generateAnnotations,
    clearAnnotationHighlight,
    scrollToFieldLocation,
  }
}
